<template>
  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.475 5.925C2.7725 5.4825 2.225 5.025 2.225 4.3125C2.225 3.495 2.9825 2.925 4.25 2.925C5.315 2.925 5.8475 3.33 6.0425 3.975C6.1325 4.275 6.38 4.5 6.695 4.5H6.92C7.415 4.5 7.7675 4.0125 7.595 3.5475C7.28 2.6625 6.545 1.9275 5.375 1.6425V1.125C5.375 0.5025 4.8725 0 4.25 0C3.6275 0 3.125 0.5025 3.125 1.125V1.62C1.67 1.935 0.5 2.88 0.5 4.3275C0.5 6.06 1.9325 6.9225 4.025 7.425C5.9 7.875 6.275 8.535 6.275 9.2325C6.275 9.75 5.9075 10.575 4.25 10.575C3.0125 10.575 2.375 10.1325 2.1275 9.5025C2.015 9.21 1.76 9 1.4525 9H1.2425C0.74 9 0.3875 9.51 0.575 9.975C1.0025 11.0175 2 11.6325 3.125 11.8725V12.375C3.125 12.9975 3.6275 13.5 4.25 13.5C4.8725 13.5 5.375 12.9975 5.375 12.375V11.8875C6.8375 11.61 8 10.7625 8 9.225C8 7.095 6.1775 6.3675 4.475 5.925Z" fill="currentColor"/>
  </svg>

</template>
<script>
export default {
  name: "DollarSign"
}
</script>
<style lang="scss" scoped>
</style>
